import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';

export default class TarotCardPicker extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.cards = null;
    this.loading = true;
    this.error = null;
    this.expanded = false;
    this.attrs.onSelect = this.attrs.onSelect || (() => {});
    this.attrs.selected = this.attrs.selected || '';
    this.attrs.selectedCode = this.attrs.selectedCode || '';
    this.attrs.allowReversed = this.attrs.allowReversed || false;
    this.attrs.isReversed = this.attrs.isReversed || false;
    this.attrs.onToggleReversed = this.attrs.onToggleReversed || (() => {});
    this.attrs.disabledCodes = this.attrs.disabledCodes || [];
    this.loadCards();
  }

  loadCards() {
    const CACHE_KEY = 'taro-cards-cache';
    const cached = sessionStorage.getItem(CACHE_KEY);
    if (cached) {
      try {
        const entry = JSON.parse(cached);
        const now = Date.now();
        const ttl = 3600000; // 1 小时
        if (entry.data && now - (entry.ts || 0) < ttl) {
          this.cards = entry.data;
          this.loading = false;
          m.redraw();
          return;
        }
      } catch (e) {
        // 缓存损坏，重新加载
      }
    }

    app
      .request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + '/taro/tarot/cards',
      })
      .then((r) => {
        this.cards = r;
        try {
          sessionStorage.setItem(CACHE_KEY, JSON.stringify({ data: r, ts: Date.now() }));
        } catch (e) {
          // sessionStorage 满了
        }
        this.loading = false;
        m.redraw();
      })
      .catch(() => {
        this.loading = false;
        this.error = '加载失败，请刷新页面重试';
        m.redraw();
      });
  }

  toggle() {
    this.expanded = !this.expanded;
    m.redraw();
  }

  selectCard(card) {
    this.attrs.onSelect(card.name_zh, card.code);
    this.expanded = false;
    m.redraw();
  }

  isDisabled(code) {
    return this.attrs.disabledCodes.includes(code);
  }

  view() {
    if (this.loading) {
      return <div className="TaroCardPicker-loading">加载塔罗牌中...</div>;
    }
    if (this.error) {
      return <div className="TaroCardPicker-error">{this.error}</div>;
    }
    if (!this.cards || !this.cards.groups) {
      return <div className="TaroCardPicker-empty">暂无数据</div>;
    }

    const selectedName = this.attrs.selected;
    const selectedCode = this.attrs.selectedCode;

    return (
      <div className="TaroCardPicker">
        <div
          className="TaroCardPicker-trigger"
          onclick={() => this.toggle()}
          role="button"
          tabIndex={0}
          onkeydown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              this.toggle();
            }
          }}
        >
          {selectedName ? (
            <span className="TaroCardPicker-selected">
              {selectedCode ? (
                <img
                  src={'/assets/extensions/taro-case/cards/' + selectedCode + '.webp'}
                  className="TaroCardPicker-thumb"
                  alt={selectedName}
                  onerror={(e) => {
                    e.target.style.display = 'none';
                  }}
                />
              ) : null}
              <span className="TaroCardPicker-selectedName">{selectedName}</span>
            </span>
          ) : (
            <span className="TaroCardPicker-placeholder">点击选牌</span>
          )}
          <i className={'fas fa-chevron-' + (this.expanded ? 'up' : 'down')}></i>
        </div>

        <div className="TaroCardPicker-panel" role="listbox" style={this.expanded ? '' : 'display:none;'}>
            {this.cards.groups.map((g) => (
              <div className="TaroCardPicker-group" key={g.group_value}>
                <div className="TaroCardPicker-groupLabel">
                  {g.group_label} ({g.options.length})
                </div>
                <div className="TaroCardPicker-cards">
                  {g.options.map((card) => {
                    const disabled = this.isDisabled(card.code);
                    return (
                      <div
                        key={card.code}
                        className={'TaroCard' + (selectedName === card.name_zh ? ' is-selected' : '') + (disabled ? ' is-disabled' : '')}
                        title={disabled ? '已被其他位置选中' : (card.name_en || card.name_zh)}
                        role="option"
                        tabIndex={disabled ? -1 : 0}
                        aria-selected={selectedName === card.name_zh}
                        aria-disabled={disabled}
                        onclick={() => { if (!disabled) this.selectCard(card); }}
                        onkeydown={(e) => {
                          if (disabled) return;
                          if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            this.selectCard(card);
                          }
                        }}
                      >
                        <img
                          src={card.image_url}
                          alt={card.name_zh}
                          loading="lazy"
                          onerror={(e) => {
                            e.target.style.opacity = '0.3';
                          }}
                        />
                        <span className="TaroCard-name">{card.name_zh}</span>
                      </div>
                    );
                  })}
                </div>
              </div>
            ))}

            {this.attrs.allowReversed ? (
              <div className="TaroCardPicker-reversed">
                <button
                  className={'TaroReverse ' + (this.attrs.isReversed ? 'is-on' : '')}
                  onclick={(e) => {
                    e.stopPropagation();
                    this.attrs.onToggleReversed();
                  }}
                  type="button"
                  title="逆位"
                >
                  R
                </button>
                <span className="TaroCardPicker-reversedHint">点亮 R 表示此牌为逆位</span>
              </div>
            ) : null}
          </div>
      </div>
    );
  }
}
